import React from 'react';
import TenantActionBar from '../components/TenantActionBar';
import TenantDetailPanel from '../components/TenantDetailPanel';
import TenantFeaturePanel from '../components/TenantFeaturePanel';
import TenantFilterBar from '../components/TenantFilterBar';
import TenantListPanel from '../components/TenantListPanel';
import TenantPlanPanel from '../components/TenantPlanPanel';
import TenantUsagePanel from '../components/TenantUsagePanel';
import useTenantAdminData from '../hooks/useTenantAdminData';
import { AppShell, PageContainer } from '../../ui-system';

const TenantAdminPage = () => {
  const {
    filteredTenants,
    selectedTenantId,
    setSelectedTenantId,
    filters,
    setFilters,
    activeTab,
    setActiveTab,
    tenantDetail,
    tenantFeatures,
    tenantModules,
    tenantUsage,
    changePlan,
    overrideFeature,
    changingPlan,
    changingFeature,
    refreshAll,
    isLoading,
    error,
  } = useTenantAdminData();

  return (
    <AppShell>
      <PageContainer>
      <div className="admin-page-surface mx-auto w-full max-w-[1900px] space-y-4 p-4 lg:py-6">
        <header className="rounded-xl border border-slate-800 bg-slate-900/70 p-4">
          <div className="text-xs uppercase tracking-[0.16em] text-slate-400">Tenant Admin SaaS Console</div>
          <h1 className="mt-1 text-2xl font-semibold">Manajemen Tenant & Paket</h1>
          <p className="mt-1 text-sm text-slate-400">Kelola tenant, paket, fitur, dan penggunaan untuk operasi SaaS multi-tenant.</p>
        </header>

        <TenantFilterBar filters={filters} setFilters={setFilters} />

        {isLoading ? <div className="rounded-xl border border-slate-800 bg-slate-900/70 p-4 text-sm text-slate-400">Memuat tenant admin console...</div> : null}
        {error ? <div className="rounded-xl border border-red-500/50 bg-red-500/10 p-4 text-sm text-red-200">{error.message || 'Gagal memuat tenant admin data'}</div> : null}

        <div className="grid gap-4 xl:grid-cols-[360px_1fr]">
          <TenantListPanel
            tenants={filteredTenants}
            selectedTenantId={selectedTenantId}
            onSelectTenant={setSelectedTenantId}
          />

          <div className="space-y-4">
            <TenantActionBar activeTab={activeTab} setActiveTab={setActiveTab} onRefresh={refreshAll} />
            <TenantDetailPanel tenant={tenantDetail} />

            {activeTab === 'plan' ? (
              <TenantPlanPanel tenant={tenantDetail} onChangePlan={changePlan} changingPlan={changingPlan} />
            ) : null}

            {activeTab === 'features' ? (
              <TenantFeaturePanel
                tenant={tenantDetail}
                features={tenantFeatures}
                modules={tenantModules}
                onOverrideFeature={overrideFeature}
                changingFeature={changingFeature}
              />
            ) : null}

            {activeTab === 'usage' ? <TenantUsagePanel usage={tenantUsage} /> : null}

            {activeTab === 'overview' ? (
              <>
                <TenantPlanPanel tenant={tenantDetail} onChangePlan={changePlan} changingPlan={changingPlan} />
                <TenantUsagePanel usage={tenantUsage} />
              </>
            ) : null}
          </div>
        </div>
      </div>
      </PageContainer>
    </AppShell>
  );
};

export default TenantAdminPage;
